import IReader from './IReader'
import ShpBean from '../beans/ShpBean'
import Axios from 'axios'
import { MiscUtil, JSONParse } from '../../miscUtil'

/**
 * 读取Shp文件
 */
export default class ShpReader extends IReader {
    constructor() {
        super(ShpBean)
        //global.CONFIG.goladminService +
        this.url = MiscUtil.getAppPath('dataset/readshp')
    }

    /**
     * 读取shp文件
     * @param {ShpBean} shpBean
     */
    async _read(shpBean) {
        const config = {
            headers: { 'Content-Type': 'multipart/form-data' }
        }
        return Axios.post(this.url, shpBean.FormData, config).then(res => {
            const obj = JSONParse(res.data.data)
            return this.group(obj)
        })
    }

    /**
     * 分组
     * @param {Object} geojsonObj
     */
    group(geojsonObj) {
        const enums = this.newEmptyGroup()
        let dataType = []
        // 分组
        const fcs = Object.values(geojsonObj).map(fc => {
            if (fc.dataType) {
                dataType = fc.dataType
            }
            const features = fc.features
            if (features.length > 0) {
                const type = features[0].geometry.type.toUpperCase()
                const ls = enums[type]
                ls && ls.push(...features)
            }

            return features
        })

        // return
        return {
            dataType,
            geojson: [].concat(...fcs),
            group: enums.toObject()
        }
    }
}
